import React, { FC, memo } from 'react'

import TitleTextField from './TitleTextField'
import TitleLinkField from './TitleLinkField'

export type Props = {
    name?: string | null
    email?: string | null
    phone?: string | null
}

const PartnerInfoCard: FC<Props> = ({ name, email, phone }) => {
    return (
        <>
            <TitleTextField dataTestId="title-text-field-provider-name" titleCode={'lblProvider'} text={name ?? '-'} />
            <TitleLinkField
                dataTestId="title-text-field-contact-email"
                titleCode={'lblContactEmail'}
                text={email ?? '-'}
                href={`mailto:${email}`}
            />
            <TitleTextField
                dataTestId="title-text-field-contact-phone"
                titleCode={'lblContactNumberField'}
                text={phone ?? '-'}
            />
        </>
    )
}

export default memo(PartnerInfoCard)
